import BigNumber from './BigNumber.js';
/**
 * @deprecated - use toChainFormat instead
 */
export default class BigNumberInWei extends BigNumber {
    static make(number) {
        return new BigNumberInWei(number);
    }
    minus(n, base) {
        return new BigNumberInWei(super.minus(n, base));
    }
    plus(n, base) {
        return new BigNumberInWei(super.plus(n, base));
    }
    dividedBy(n, base) {
        return new BigNumberInWei(super.dividedBy(n, base));
    }
    div(n, base) {
        return new BigNumberInWei(super.div(n, base));
    }
    multipliedBy(n, base) {
        return new BigNumberInWei(super.multipliedBy(n, base));
    }
    times(n, base) {
        return new BigNumberInWei(super.times(n, base));
    }
    pow(n, base) {
        return new BigNumberInWei(super.pow(n, base));
    }
    toBase(decimals = 18) {
        return new BigNumber(this).dividedBy(new BigNumber(10).pow(decimals));
    }
}
